const STORAGE_KEY = 'app_theme';
export const setTheme = (theme) => {
    const el = document.documentElement;
    if (theme === 'dark')
        el.classList.add('dark');
    else
        el.classList.remove('dark');
    try {
        localStorage.setItem(STORAGE_KEY, theme);
    }
    catch (error) {
        console.error('Error saving theme:', error);
    }
};
export const initTheme = () => {
    try {
        const saved = localStorage.getItem(STORAGE_KEY);
        if (saved === 'light' || saved === 'dark') {
            setTheme(saved);
            return;
        }
    }
    catch (error) {
        console.error('Error initializing theme:', error);
    }
    if (typeof window !== 'undefined' &&
        window.matchMedia &&
        window.matchMedia('(prefers-color-scheme: dark)').matches) {
        setTheme('dark');
    }
    else {
        setTheme('light');
    }
};
